export default __webpack_public_path__ + "static/dynamic-ai-dark-97c814b2097b742b5f32eaf7bb3eff8f.png";